import React, {PureComponent} from 'react';

import {Button, Classes, MenuItem, Overlay, Callout} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import http from "../../services/httpService";
import {default as authService} from "../../services/authService";
import toastr from "toastr";


export default class DeleteShortLinkModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        selectedDomain: this.props.selectedDomain,
        shortCode: this.props.shortCode,
        domains: ['https://oo.fyi/', 'https://s.emitto.io/'],
        error: false,
        loader: false

    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }


    componentDidUpdate = async () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
        if (this.state.shortCode !== this.props.shortCode) {
            //console.log('shortCodeChanged');
            //console.log('shortCode :', this.props.shortCode);
            await this.setState({
                shortCode: this.props.shortCode
            })
        }
    }


    handleShortCode = (shortCode) => {
        this.setState({shortCode: shortCode})
    }
    domainRender = (item, {modifiers, handleClick}) => {

        return (

            <MenuItem
                key={item}
                text={item}
                value={item}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />
        )
    };


    domainItemSelect = (item) => {
        this.setState({selectedDomain: item})
    }
    checkCode = async () => {
        let data = {
            code: this.state.shortCode
        };

        try {
            const result = await http.post("https://oo.fyi/code-check", data, {
                headers: {
                    authorization: authService.getJwt()
                }
            });

            //console.log('code result: ', result);

            if (result.data.body.message === "No short url with that code exists.") {
                this.setState({error: false})
                this.props.saveShortCode(this.state.shortCode, this.state.selectedDomain)
            } else {
                this.setState({error: true})
            }


        } catch (e) {
            toastr.error(e);
        }


    }

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER + ' customize-short-link-modal'}
                isOpen={this.state.overlayIsOpen}

                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field-payment"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className='modal-title'>
                        <p className="modal-close-button" onClick={this.props.handleClose}><i
                            className="fas fa-times"></i></p>
                        <h2 className=''>Delete Short Link</h2>
                    </div>
                    <div className="modal-main">
                        <div className='margin-top-20 margin-bottom-20'>

                            <span>Are you sure that you want to delete this short link?</span>
                        </div>

                        <div className='justify-content-end flex-direction-row margin-bottom-30'>
                            <button
                                className="btn-white-border margin-right-10"
                                disabled={false}
                                onClick={() => {
                                    this.props.handleClose()
                                }}>
                                Cancel
                            </button>

                            {this.props.loaderActive ?
                                <button
                                    className="btn-danger btn-spinner"
                                    disabled={true}
                                >
                                    Delete <i className='fa fa-spin fa-spinner'></i>
                                </button>
                                :
                                <button
                                    className="btn-danger"
                                    disabled={false}
                                    onClick={this.props.deleteShortCode}>
                                    Delete
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}